module.exports = __webpack_public_path__ + "./images/334942078132aa4fa6bdf73c828d2a7e.webp";